/**
 * Utilidades para validar el estado de clientes en SAP B1
 */

import { SistematizacionResponse } from '../types/sistematizacion.types';

export interface CustomerStatus {
  isActive: boolean;
  reason: 'inactive' | 'frozen' | null;
  message: string;
}

/**
 * Valida si un cliente está activo basándose en los campos Valid y Frozen de SAP B1
 *
 * @param data - Datos de sistematización que pueden contener info del cliente
 * @returns Estado del cliente con razón si está inactivo
 */
export const validateCustomerStatus = (data: SistematizacionResponse[]): CustomerStatus => {
  // Si no hay datos o no hay información de cliente, asumir activo
  if (!data || data.length === 0) {
    return {
      isActive: true,
      reason: null,
      message: 'No hay información de cliente disponible',
    };
  }

  // Tomar el primer registro para obtener info del cliente
  const firstRecord = data[0];

  // Si no tiene campos de cliente, asumir que no hay validación necesaria
  if (!firstRecord.CardCode) {
    return {
      isActive: true,
      reason: null,
      message: 'Cliente no identificado en el sistema',
    };
  }

  // Validar si el cliente está congelado
  if (firstRecord.Frozen === 'tYES') {
    return {
      isActive: false,
      reason: 'frozen',
      message: `El cliente ${firstRecord.CardName || firstRecord.CardCode} está congelado en SAP B1`,
    };
  }

  // Validar si el cliente está inactivo
  if (firstRecord.Valid === 'tNO') {
    return {
      isActive: false,
      reason: 'inactive',
      message: `El cliente ${firstRecord.CardName || firstRecord.CardCode} está inactivo en SAP B1`,
    };
  }

  // Cliente activo
  return {
    isActive: true,
    reason: null,
    message: 'Cliente activo',
  };
};

/**
 * Determina si se debe mostrar la alerta de cliente inactivo
 */
export const shouldShowInactiveAlert = (status: CustomerStatus): boolean => {
  return !status.isActive && (status.reason === 'inactive' || status.reason === 'frozen');
};
